import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { CandidateFile } from '@/types/candidates';
import { CvViewer } from './cv-viewer';

interface CandidateFilePreviewDialogProps {
  file: CandidateFile | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CandidateFilePreviewDialog({
  file,
  open,
  onOpenChange,
}: CandidateFilePreviewDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[90vh] max-h-[90vh] w-[92vw] max-w-[1200px] flex-col p-0 sm:max-w-[1200px]">
        <DialogHeader className="shrink-0 border-b border-border px-5 py-3">
          <DialogTitle className="truncate text-sm">
            {file?.filename ?? 'Preview'}
          </DialogTitle>
          <DialogDescription className="text-xs">
            {file ? `v${file.version}${file.isLatest ? ' · latest' : ''}` : null}
          </DialogDescription>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-hidden p-3">
          {file ? (
            <CvViewer
              fileUrl={file.url}
              filename={file.filename}
              mimeType={file.mimeType}
            />
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}
